/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Sms_WhenInputs */

const en_portal_remind_sms_when = /** @type {(inputs: Portal_Remind_Sms_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text · the day before`)
};

const pl_portal_remind_sms_when = /** @type {(inputs: Portal_Remind_Sms_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS · dzień wcześniej`)
};

/**
* | output |
* | --- |
* | "Text · the day before" |
*
* @param {Portal_Remind_Sms_WhenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_sms_when = /** @type {((inputs?: Portal_Remind_Sms_WhenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Sms_WhenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_sms_when(inputs)
	return en_portal_remind_sms_when(inputs)
});